import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router';

import { CustomButton } from '~/shared/components/custom_button';

export interface UserProfileSectionProps {
  firstName: string;
  profileImageUrl?: string;
  isSidebarOpen: boolean;
  onLogoutClick: () => void;
  profilePath: string;
  onMobileNavigate?: () => void;
}

export function UserProfileSection({
  firstName,
  profileImageUrl,
  isSidebarOpen,
  onLogoutClick,
  profilePath,
  onMobileNavigate,
}: UserProfileSectionProps) {
  return (
    <div className="px-4 py-2 pb-5">
      <div
        className={`flex w-full transition-all duration-300 ease-in-out ${isSidebarOpen ? 'flex-row items-center justify-between gap-0' : 'flex-col items-center justify-center gap-4'}`}
      >
        <Link
          to={profilePath}
          onClick={onMobileNavigate}
        >
          <div
            className={`flex items-center transition-all duration-300 ease-in-out ${isSidebarOpen ? 'w-auto flex-row justify-start' : 'w-full flex-col justify-center'}`}
          >
            {/* Avatar */}
            <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-neutralLight">
              {profileImageUrl ? (
                <img
                  src={profileImageUrl}
                  alt="profile"
                  className="h-8 w-8 overflow-hidden rounded-full"
                />
              ) : (
                <span className="bodySm text-neutralUltraDark">
                  {firstName?.charAt(0).toUpperCase()}
                </span>
              )}
            </div>

            {/* Name */}
            <div
              className={`ml-3 min-w-0 transition-all duration-300 ease-in-out ${isSidebarOpen ? '' : 'ml-0 mt-2'}`}
            >
              <p
                className="bodySm truncate whitespace-nowrap text-center text-white transition-opacity duration-300 ease-in-out"
                style={{ opacity: isSidebarOpen ? 1 : 0 }}
              >
                {firstName}
              </p>
            </div>
          </div>
        </Link>

        <CustomButton
          variant="surface"
          buttonType="text"
          type="button"
          aria-label="Logout"
          className={`rounded-full p-2.5 transition-all duration-300 ease-in-out hover:bg-primaryUltraDark ${isSidebarOpen ? '' : 'mx-auto'}`}
          onClick={onLogoutClick}
        >
          <ArrowRightOnRectangleIcon className="h-6 w-6 text-white" />
        </CustomButton>
      </div>
    </div>
  );
}
